<template>
    <e-mobile-modal :value="value" position="center" @input="$emit('input', $event)" :title="$t('map.qrCode')" :description="floorName" :close-on-backdrop="false">
        <div class="qr-result-modal">
            <!-- <div class="qr-result-prompt">
                <span v-if="mode !== 'reposition'">{{ $t('map.assistant.qrCodeScanner.startFromPrompt') }}</span>
                <span v-else>{{ $t('map.assistant.qrCodeScanner.repositionPrompt') }}</span>
            </div> -->

            <div v-if="image360" class="qr-result-image qr-result-image-360">
                <pano-360-pannellum :src="image360" hide-actions image-only auto-rotate />
            </div>
            <div v-else-if="previewImage" class="qr-result-image">
                <b-img :src="previewImage" fluid />
            </div>
        </div>

        <template #footer>
            <b-btn variant="accent" size="lg" block @click="$emit('confirm')">
                <span>{{ $t('map.startFrom') }}</span>
            </b-btn>
        </template>
    </e-mobile-modal>
</template>

<script>
import EMobileModal from '@/components/e-mobile-modal.vue';
import Pano360Pannellum from '@/components/pano-360-pannellum.vue';

export default {
    name: `map-mobile-qr-location-modal`,
    components: { EMobileModal, Pano360Pannellum },
    props: {
        value: { type: Boolean, default: false },
        mapItem: { type: Object, default: null },
        mode: { type: String, default: `start-from` },
    },
    computed: {
        image360() {
            if (!this.mapItem) {
                return null;
            }
            return this.mapItem.image360;
        },
        displayName() {
            if (!this.mapItem) {
                return ``;
            }
            return this.mapItem.getFullName ? this.mapItem.getFullName() : this.mapItem.getName();
        },
        secondaryValue() {
            if (!this.mapItem || !this.mapItem.cmsItem || !this.mapItem.cmsItem.getSecondaryValue) {
                return null;
            }
            return this.$tr(this.mapItem.cmsItem.getSecondaryValue());
        },
        previewImage() {
            if (!this.mapItem) {
                return null;
            }
            if (this.mapItem.cmsItem && this.mapItem.cmsItem.getPreviewImage) {
                return this.mapItem.cmsItem.getPreviewImage();
            }
            return this.mapItem.image || null;
        },
        floorName() {
            if (!this.mapItem || !this.mapItem.map || !this.mapItem.floorId) {
                return `-`;
            }
            const floor = this.mapItem.map.getFloorById(this.mapItem.floorId);
            if (!floor) {
                return `-`;
            }
            return this.$tr(floor.getName());
        },
        officeValue() {
            if (!this.mapItem || !this.mapItem.cmsItem || !this.mapItem.cmsItem.office) {
                return `-`;
            }
            return this.$tr(this.mapItem.cmsItem.office);
        },
    },
};
</script>

<style lang="scss" scoped>
.qr-result-modal {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.qr-result-image {
    overflow: hidden;
    border-radius: 16px;
    background: #f4f5f7;

    img {
        width: 100%;
        max-height: 180px;
        object-fit: cover;
    }
}

.qr-result-image-360 {
    height: 220px;
    background: #020508;

    :deep(.pano-360) {
        width: 100%;
        height: 100%;
    }

    :deep(.pano-360-container),
    :deep(.pnlm-container) {
        width: 100%;
        height: 100%;
    }
}

.qr-result-title {
    font-size: 16pt;
    font-weight: 700;
    line-height: 1.2;
}

.qr-result-secondary {
    font-size: 11pt;
    color: var(--color-muted);
}

.qr-result-prompt {
    text-align: center;
    font-size: 14pt;
    line-height: 1.45;
    color: #243140;
}
</style>




